import React from 'react';

import { QuoteWithButtons } from '@components/index';
import { contacts } from '@store/ContactData';
import { Challenge, Header, KeyFeatures, Result } from './components';
import { GroupedCaseStudy } from '@layouts/CaseStudies/types';

export const DetailedCaseStudy: React.FC<GroupedCaseStudy> = (data) => {
	return (
		<>
			<Header {...data.general} />
			<Challenge {...data.challenge} />
			{data.keyFeatures.features && <KeyFeatures {...data.keyFeatures} />}
			<Result {...data.result} />
			<QuoteWithButtons
				className="gray-bg"
				author={{
					name: contacts[0].name,
					position: contacts[0].position,
					email: contacts[0].email,
					linkedIn: contacts[0].linkedin,
					photo: contacts[0].image,
				}}
			>
				<h2 className="font-size-22 mb-2 pr-5">
					What kind of competencies are you looking for?
				</h2>
				<p className="font-size-sm">
					Contact me to discuss your requirements and build your dedicated IT
					team together with us.
				</p>
			</QuoteWithButtons>
		</>
	);
};
